import { apiClient } from "api/client";

export async function createReceiptApi(body) {
  const { data } = await apiClient.post("/post/receipt/create", body);
  return data;
}
